export default "__VITE_ASSET__jJAqikIP__";